// extracted by mini-css-extract-plugin
export default {"save-container":"SavePrompt_save-container__WwbtJ","show-prompt":"SavePrompt_show-prompt__YQrh5"};